/* eslint-disable no-underscore-dangle */
import { AutoboardVehicle } from '../../../src/app/@shared-types/vehicle';
import { Price, VehicleCosts } from '../../../src/app/@shared-types/vehicle/vehicle';
import ObjectService from '../../../src/app/shared/services/object';
import { SalesAPIService } from '../../../shared/api/sales-api.service';
import { DeepPartial } from '../../../src/app/@shared-types';
import { VehicleFormComponentExitFunction } from '../../../src/app/@types/vehicle';

export class PricingFormController {
  private exit!: (data: VehicleFormComponentExitFunction) => void;

  private objectService: ObjectService;

  private salesApiService: SalesAPIService;

  public vehicle!: AutoboardVehicle;

  public sending = false;

  public updateData: {
    price: Price,
    costs: VehicleCosts,
  } | null = null;

  /* @ngInject */
  constructor(
    objectService: ObjectService,
    salesApiService: SalesAPIService,
  ) {
    this.objectService = objectService;
    this.salesApiService = salesApiService;
  }

  public $onInit = (): void => {
    this.updateData = {
      costs: this.objectService.deepCopy(this.vehicle.vehicleData.costs),
      price: this.objectService.deepCopy(this.vehicle.vehicleData.price),
    };
  };

  public formTransmission = async (): Promise<void> => {
    this.sending = true;

    const changedVals: DeepPartial<AutoboardVehicle> = {
      _id: this.vehicle._id,
      vehicleData: {
        costs: this.updateData?.costs,
        price: this.updateData?.price,
      },
    };

    await this.salesApiService.putVehicle(changedVals);

    return this.exit({});
  };
}
